import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const TaskButton = () => (
  <div className="ui two buttons">
    <Button basic as={Link} to="/task/new" primary>New task</Button>
  </div>
);

export default TaskButton;



// WEBPACK FOOTER //
// ./src/component/TaskButton.js